import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { Course } from '../../../api/courses'
import { AdminTransaction } from '../../../api/transaction'

interface EditTransactionModalProps {
  visible: boolean
  onClose: () => void
  onSubmit: (data: {
    order_id: string
    course_id: number
    email: string
    fullname: string,
    total: number
    status: string
  }) => void
  transaction: AdminTransaction | null
  courses: Course[]
  loading?: boolean
}

const statusOptions = [
  { label: 'Paid', value: 'paid' },
  { label: 'Pending', value: 'pending' },
  { label: 'Failed', value: 'failed' },
]

const EditTransactionModal: React.FC<EditTransactionModalProps> = ({
  visible,
  onClose,
  onSubmit,
  transaction,
  courses,
  loading,
}) => {
  const [form, setForm] = useState({
    order_id: '',
    course_id: 0,
    email: '',
    fullname: '',
    total: 0,
    status: '',
    notes: '', // tambahkan notes
  })

  useEffect(() => {
    if (transaction) {
      setForm({
        order_id: transaction.order_id || '',
        course_id: Number(transaction.course_id) || 0,
        email: transaction.email || '',
        fullname: transaction.fullname || '',
        total: Number(transaction.total) || 0,
        status: transaction.status || '',
        notes: transaction.notes || '', // set notes
      })
    }
  }, [transaction])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSelectChange = (name: string, value: any) => {
    setForm({ ...form, [name]: value })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <>
      {visible && (
        <div
          className="modal-backdrop fade show"
          style={{ zIndex: 1040 }}
          onClick={onClose}
        />
      )}
      <div
        className={`modal fade${visible ? ' show d-block' : ''}`}
        tabIndex={-1}
        style={{ display: visible ? 'block' : 'none', zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="fw-bold">Edit Transaction</h5>
              <button
                type="button"
                className="btn-close custom-btn-close"
                aria-label="Close"
                onClick={onClose}
              >
                <i className="isax isax-close-circle5" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Order ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="order_id"
                        value={form.order_id}
                        onChange={handleChange}
                        required
                        disabled={transaction && transaction.type !== 'manual'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Nama <span className="text-danger">*</span>
                      </label>
                      <input
                        type="fullname"
                        className="form-control"
                        name="fullname"
                        value={form.fullname}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Course <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={courses.map((c) => ({
                          label: c.title,
                          value: c.id,
                        }))}
                        className="select d-flex"
                        placeholder="Select Course"
                        value={form.course_id}
                        onChange={(val: any) =>
                          handleSelectChange('course_id', val)
                        }
                        style={{ width: '100%' }}
                        disabled={transaction && transaction.type !== 'manual'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        disabled={transaction && transaction.type !== 'manual'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Amount <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="total"
                        value={form.total}
                        onChange={handleChange}
                        required
                        disabled={transaction && transaction.type !== 'manual'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Status</label>
                      <Select
                        options={statusOptions}
                        className="select d-flex"
                        placeholder="Select Status"
                        value={form.status}
                        onChange={(val: any) =>
                          handleSelectChange('status', val)
                        }
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Notes</label>
                      <textarea
                        className="form-control"
                        name="notes"
                        value={form.notes}
                        onChange={handleChange}
                        rows={3}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn bg-gray-100 rounded-pill me-2"
                  type="button"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-secondary rounded-pill"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditTransactionModal
